import { html } from "uhtml";
import { locales, availableLocales } from "../../models/locales.js";
import { safeHref } from "../../models/safe-href.js";
import { locale } from "../../view-models/app-signals";

const localeNames = {
	ca: "català",
	cy: "Cymraeg",
	da: "dansk",
	de: "Deutsch",
	en: "English",
	es: "español",
	fr: "français",
	it: "italiano",
	nl: "Nederlands",
	"pt-BR": "português (Brasil)",
	ru: "русский",
};

export function changeLocale(language = "en") {
	locale(language);
}

export function localeRender(name, label, locale) {
	const locales = availableLocales().map((tag) => {
		return { tag, name: localeNames[tag] || tag };
	});
	const current = { tag: locale, name: localeNames[locale] || locale };
	function change(event) {
		if (event.target !== null) {
			const target = event.target;
			const selected = locales.find((item) => item.tag === target.value);
			if (selected) {
				changeLocale(selected.tag);
			}
		}
	}
	return html`<div
    class="settings-options settings-options-font settings-options-locale"
  >
    <label class="settings-label" for="${name + "-id"}">${label}</label>
    <select
      class="settings-select"
      id="${name + "-id"}"
      name="${name}"
      @change=${change}
    >
      ${locales.map(
				(item) =>
					html`<option
            value="${item.tag}"
            ?selected=${current?.tag === item.tag}
          >
            ${item.name}
          </option>`,
			)}
    </select>
  </div>`;
}

/**
 * Embedders pass tosLink as { url, label } (url a URL or a string), as for
 * the EPUB reader; a bare URL string is accepted too.
 */
function tosLinkParts(tosLink, locale) {
	const url = tosLink && typeof tosLink === "object" ? tosLink.url : tosLink;
	const label =
		(tosLink && typeof tosLink === "object" && tosLink.label) ||
		locales.tosDefault[locale];
	return { href: safeHref(url), label };
}

export function settingsForm(locale, { tosLink }) {
	const tos = tosLinkParts(tosLink, locale);
	return html`<form
      class="settings-menu"
      @submit="${(ev) => ev.preventDefault()}"
      aria-label="${locales.settings[locale]}"
      id="cassis-settings-form"
    >
      ${localeRender(
				"locale-settings",
				locales.selectLanguage[locale] || locales.selectLanguage.en,
				locale,
			)}
      <div class="about-this-book">
          <button
            id="about-book"
            class="about-book"
            type="button"
            data-type="open-dialog"
            data-alternate-dialog="#book-info-dialog"
          >
            ${locales.aboutThisBook[locale]}
          </button>
        </div>
      <div class="tos-link" ?hidden=${!tos.href}><a href="${tos.href}" target="_blank" rel="noopener" tabindex="0">${tos.label}</a></div>

      <jb-close-button class="about-this-book">

      <button
        type="button"
        data-type="close-dialog"
        tabindex="0"
      >
        ${locales.closeIcon[locale]}
      </button>

      </jb-close-button>
    </form>`;
}
